var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "value": _vm.showsAuth,
      "persistent": "",
      "width": "560"
    }
  }, [_c('v-card', _vm._b({
    staticClass: "ma-0 black",
    attrs: {
      "dark": "",
      "tile": ""
    }
  }, 'v-card', {
    loading: _vm.loading
  }, false), [_c('v-card-text', {
    staticClass: "py-24"
  }, [_vm._v(" 승인받지 않은 사용자의 참여 요청이 왔습니다. "), _c('br'), _vm._v(" 참여를 승인하시겠습니까? "), _c('auth-seekers', {
    staticClass: "mt-16",
    model: {
      value: _vm.selected,
      callback: function ($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  })], 1), _c('v-card-actions', {
    staticClass: "px-24 pt-0 pb-16"
  }, [_c('v-row', [_c('v-col', [_c('v-btn', _vm._b({
    attrs: {
      "block": "",
      "color": "secondary"
    },
    on: {
      "click": _vm.reject
    }
  }, 'v-btn', {
    disabled: _vm.disabled
  }, false), [_vm._v("거부하기")])], 1), _c('v-col', [_c('v-btn', _vm._b({
    attrs: {
      "block": "",
      "color": "primary"
    },
    on: {
      "click": _vm.approve
    }
  }, 'v-btn', {
    disabled: _vm.disabled
  }, false), [_vm._v("승인하기")])], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }